.root {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: var(--mantine-color-body);
    padding-top: var(--mantine-spacing-xl);
    padding-bottom: var(--mantine-spacing-sm);
}

.titleColumn {
    min-width: 0;
}

.title {
    margin: 0;
}

.toolbar {
    margin-left: auto;
    min-width: 0;
    max-width: 100%;
}
